__turbopack_context__.v({
  "align-baseline": "Flex-module-scss-module__GVHfLa__align-baseline",
  "align-center": "Flex-module-scss-module__GVHfLa__align-center",
  "align-end": "Flex-module-scss-module__GVHfLa__align-end",
  "align-start": "Flex-module-scss-module__GVHfLa__align-start",
  "align-stretch": "Flex-module-scss-module__GVHfLa__align-stretch",
  "dir-column": "Flex-module-scss-module__GVHfLa__dir-column",
  "dir-column-reverse": "Flex-module-scss-module__GVHfLa__dir-column-reverse",
  "dir-row": "Flex-module-scss-module__GVHfLa__dir-row",
  "dir-row-reverse": "Flex-module-scss-module__GVHfLa__dir-row-reverse",
  "flex": "Flex-module-scss-module__GVHfLa__flex",
  "gap-0": "Flex-module-scss-module__GVHfLa__gap-0",
  "gap-1": "Flex-module-scss-module__GVHfLa__gap-1",
  "gap-10": "Flex-module-scss-module__GVHfLa__gap-10",
  "gap-12": "Flex-module-scss-module__GVHfLa__gap-12",
  "gap-14": "Flex-module-scss-module__GVHfLa__gap-14",
  "gap-16": "Flex-module-scss-module__GVHfLa__gap-16",
  "gap-18": "Flex-module-scss-module__GVHfLa__gap-18",
  "gap-2": "Flex-module-scss-module__GVHfLa__gap-2",
  "gap-20": "Flex-module-scss-module__GVHfLa__gap-20",
  "gap-22": "Flex-module-scss-module__GVHfLa__gap-22",
  "gap-24": "Flex-module-scss-module__GVHfLa__gap-24",
  "gap-3": "Flex-module-scss-module__GVHfLa__gap-3",
  "gap-4": "Flex-module-scss-module__GVHfLa__gap-4",
  "gap-5": "Flex-module-scss-module__GVHfLa__gap-5",
  "gap-6": "Flex-module-scss-module__GVHfLa__gap-6",
  "gap-8": "Flex-module-scss-module__GVHfLa__gap-8",
  "grow": "Flex-module-scss-module__GVHfLa__grow",
  "inline": "Flex-module-scss-module__GVHfLa__inline",
  "justify-around": "Flex-module-scss-module__GVHfLa__justify-around",
  "justify-between": "Flex-module-scss-module__GVHfLa__justify-between",
  "justify-center": "Flex-module-scss-module__GVHfLa__justify-center",
  "justify-end": "Flex-module-scss-module__GVHfLa__justify-end",
  "justify-evenly": "Flex-module-scss-module__GVHfLa__justify-evenly",
  "justify-start": "Flex-module-scss-module__GVHfLa__justify-start",
  "lg-align-baseline": "Flex-module-scss-module__GVHfLa__lg-align-baseline",
  "lg-align-center": "Flex-module-scss-module__GVHfLa__lg-align-center",
  "lg-align-end": "Flex-module-scss-module__GVHfLa__lg-align-end",
  "lg-align-start": "Flex-module-scss-module__GVHfLa__lg-align-start",
  "lg-align-stretch": "Flex-module-scss-module__GVHfLa__lg-align-stretch",
  "lg-dir-column": "Flex-module-scss-module__GVHfLa__lg-dir-column",
  "lg-dir-column-reverse": "Flex-module-scss-module__GVHfLa__lg-dir-column-reverse",
  "lg-dir-row": "Flex-module-scss-module__GVHfLa__lg-dir-row",
  "lg-dir-row-reverse": "Flex-module-scss-module__GVHfLa__lg-dir-row-reverse",
  "lg-gap-0": "Flex-module-scss-module__GVHfLa__lg-gap-0",
  "lg-gap-1": "Flex-module-scss-module__GVHfLa__lg-gap-1",
  "lg-gap-10": "Flex-module-scss-module__GVHfLa__lg-gap-10",
  "lg-gap-12": "Flex-module-scss-module__GVHfLa__lg-gap-12",
  "lg-gap-14": "Flex-module-scss-module__GVHfLa__lg-gap-14",
  "lg-gap-16": "Flex-module-scss-module__GVHfLa__lg-gap-16",
  "lg-gap-18": "Flex-module-scss-module__GVHfLa__lg-gap-18",
  "lg-gap-2": "Flex-module-scss-module__GVHfLa__lg-gap-2",
  "lg-gap-20": "Flex-module-scss-module__GVHfLa__lg-gap-20",
  "lg-gap-22": "Flex-module-scss-module__GVHfLa__lg-gap-22",
  "lg-gap-24": "Flex-module-scss-module__GVHfLa__lg-gap-24",
  "lg-gap-3": "Flex-module-scss-module__GVHfLa__lg-gap-3",
  "lg-gap-4": "Flex-module-scss-module__GVHfLa__lg-gap-4",
  "lg-gap-5": "Flex-module-scss-module__GVHfLa__lg-gap-5",
  "lg-gap-6": "Flex-module-scss-module__GVHfLa__lg-gap-6",
  "lg-gap-8": "Flex-module-scss-module__GVHfLa__lg-gap-8",
  "lg-justify-around": "Flex-module-scss-module__GVHfLa__lg-justify-around",
  "lg-justify-between": "Flex-module-scss-module__GVHfLa__lg-justify-between",
  "lg-justify-center": "Flex-module-scss-module__GVHfLa__lg-justify-center",
  "lg-justify-end": "Flex-module-scss-module__GVHfLa__lg-justify-end",
  "lg-justify-evenly": "Flex-module-scss-module__GVHfLa__lg-justify-evenly",
  "lg-justify-start": "Flex-module-scss-module__GVHfLa__lg-justify-start",
  "lg-wrap-nowrap": "Flex-module-scss-module__GVHfLa__lg-wrap-nowrap",
  "lg-wrap-wrap": "Flex-module-scss-module__GVHfLa__lg-wrap-wrap",
  "lg-wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__lg-wrap-wrap-reverse",
  "md-align-baseline": "Flex-module-scss-module__GVHfLa__md-align-baseline",
  "md-align-center": "Flex-module-scss-module__GVHfLa__md-align-center",
  "md-align-end": "Flex-module-scss-module__GVHfLa__md-align-end",
  "md-align-start": "Flex-module-scss-module__GVHfLa__md-align-start",
  "md-align-stretch": "Flex-module-scss-module__GVHfLa__md-align-stretch",
  "md-dir-column": "Flex-module-scss-module__GVHfLa__md-dir-column",
  "md-dir-column-reverse": "Flex-module-scss-module__GVHfLa__md-dir-column-reverse",
  "md-dir-row": "Flex-module-scss-module__GVHfLa__md-dir-row",
  "md-dir-row-reverse": "Flex-module-scss-module__GVHfLa__md-dir-row-reverse",
  "md-gap-0": "Flex-module-scss-module__GVHfLa__md-gap-0",
  "md-gap-1": "Flex-module-scss-module__GVHfLa__md-gap-1",
  "md-gap-10": "Flex-module-scss-module__GVHfLa__md-gap-10",
  "md-gap-12": "Flex-module-scss-module__GVHfLa__md-gap-12",
  "md-gap-14": "Flex-module-scss-module__GVHfLa__md-gap-14",
  "md-gap-16": "Flex-module-scss-module__GVHfLa__md-gap-16",
  "md-gap-18": "Flex-module-scss-module__GVHfLa__md-gap-18",
  "md-gap-2": "Flex-module-scss-module__GVHfLa__md-gap-2",
  "md-gap-20": "Flex-module-scss-module__GVHfLa__md-gap-20",
  "md-gap-22": "Flex-module-scss-module__GVHfLa__md-gap-22",
  "md-gap-24": "Flex-module-scss-module__GVHfLa__md-gap-24",
  "md-gap-3": "Flex-module-scss-module__GVHfLa__md-gap-3",
  "md-gap-4": "Flex-module-scss-module__GVHfLa__md-gap-4",
  "md-gap-5": "Flex-module-scss-module__GVHfLa__md-gap-5",
  "md-gap-6": "Flex-module-scss-module__GVHfLa__md-gap-6",
  "md-gap-8": "Flex-module-scss-module__GVHfLa__md-gap-8",
  "md-justify-around": "Flex-module-scss-module__GVHfLa__md-justify-around",
  "md-justify-between": "Flex-module-scss-module__GVHfLa__md-justify-between",
  "md-justify-center": "Flex-module-scss-module__GVHfLa__md-justify-center",
  "md-justify-end": "Flex-module-scss-module__GVHfLa__md-justify-end",
  "md-justify-evenly": "Flex-module-scss-module__GVHfLa__md-justify-evenly",
  "md-justify-start": "Flex-module-scss-module__GVHfLa__md-justify-start",
  "md-wrap-nowrap": "Flex-module-scss-module__GVHfLa__md-wrap-nowrap",
  "md-wrap-wrap": "Flex-module-scss-module__GVHfLa__md-wrap-wrap",
  "md-wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__md-wrap-wrap-reverse",
  "sm-align-baseline": "Flex-module-scss-module__GVHfLa__sm-align-baseline",
  "sm-align-center": "Flex-module-scss-module__GVHfLa__sm-align-center",
  "sm-align-end": "Flex-module-scss-module__GVHfLa__sm-align-end",
  "sm-align-start": "Flex-module-scss-module__GVHfLa__sm-align-start",
  "sm-align-stretch": "Flex-module-scss-module__GVHfLa__sm-align-stretch",
  "sm-dir-column": "Flex-module-scss-module__GVHfLa__sm-dir-column",
  "sm-dir-column-reverse": "Flex-module-scss-module__GVHfLa__sm-dir-column-reverse",
  "sm-dir-row": "Flex-module-scss-module__GVHfLa__sm-dir-row",
  "sm-dir-row-reverse": "Flex-module-scss-module__GVHfLa__sm-dir-row-reverse",
  "sm-gap-0": "Flex-module-scss-module__GVHfLa__sm-gap-0",
  "sm-gap-1": "Flex-module-scss-module__GVHfLa__sm-gap-1",
  "sm-gap-10": "Flex-module-scss-module__GVHfLa__sm-gap-10",
  "sm-gap-12": "Flex-module-scss-module__GVHfLa__sm-gap-12",
  "sm-gap-14": "Flex-module-scss-module__GVHfLa__sm-gap-14",
  "sm-gap-16": "Flex-module-scss-module__GVHfLa__sm-gap-16",
  "sm-gap-18": "Flex-module-scss-module__GVHfLa__sm-gap-18",
  "sm-gap-2": "Flex-module-scss-module__GVHfLa__sm-gap-2",
  "sm-gap-20": "Flex-module-scss-module__GVHfLa__sm-gap-20",
  "sm-gap-22": "Flex-module-scss-module__GVHfLa__sm-gap-22",
  "sm-gap-24": "Flex-module-scss-module__GVHfLa__sm-gap-24",
  "sm-gap-3": "Flex-module-scss-module__GVHfLa__sm-gap-3",
  "sm-gap-4": "Flex-module-scss-module__GVHfLa__sm-gap-4",
  "sm-gap-5": "Flex-module-scss-module__GVHfLa__sm-gap-5",
  "sm-gap-6": "Flex-module-scss-module__GVHfLa__sm-gap-6",
  "sm-gap-8": "Flex-module-scss-module__GVHfLa__sm-gap-8",
  "sm-justify-around": "Flex-module-scss-module__GVHfLa__sm-justify-around",
  "sm-justify-between": "Flex-module-scss-module__GVHfLa__sm-justify-between",
  "sm-justify-center": "Flex-module-scss-module__GVHfLa__sm-justify-center",
  "sm-justify-end": "Flex-module-scss-module__GVHfLa__sm-justify-end",
  "sm-justify-evenly": "Flex-module-scss-module__GVHfLa__sm-justify-evenly",
  "sm-justify-start": "Flex-module-scss-module__GVHfLa__sm-justify-start",
  "sm-wrap-nowrap": "Flex-module-scss-module__GVHfLa__sm-wrap-nowrap",
  "sm-wrap-wrap": "Flex-module-scss-module__GVHfLa__sm-wrap-wrap",
  "sm-wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__sm-wrap-wrap-reverse",
  "wrap-nowrap": "Flex-module-scss-module__GVHfLa__wrap-nowrap",
  "wrap-wrap": "Flex-module-scss-module__GVHfLa__wrap-wrap",
  "wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__wrap-wrap-reverse",
  "xl-align-baseline": "Flex-module-scss-module__GVHfLa__xl-align-baseline",
  "xl-align-center": "Flex-module-scss-module__GVHfLa__xl-align-center",
  "xl-align-end": "Flex-module-scss-module__GVHfLa__xl-align-end",
  "xl-align-start": "Flex-module-scss-module__GVHfLa__xl-align-start",
  "xl-align-stretch": "Flex-module-scss-module__GVHfLa__xl-align-stretch",
  "xl-dir-column": "Flex-module-scss-module__GVHfLa__xl-dir-column",
  "xl-dir-column-reverse": "Flex-module-scss-module__GVHfLa__xl-dir-column-reverse",
  "xl-dir-row": "Flex-module-scss-module__GVHfLa__xl-dir-row",
  "xl-dir-row-reverse": "Flex-module-scss-module__GVHfLa__xl-dir-row-reverse",
  "xl-gap-0": "Flex-module-scss-module__GVHfLa__xl-gap-0",
  "xl-gap-1": "Flex-module-scss-module__GVHfLa__xl-gap-1",
  "xl-gap-10": "Flex-module-scss-module__GVHfLa__xl-gap-10",
  "xl-gap-12": "Flex-module-scss-module__GVHfLa__xl-gap-12",
  "xl-gap-14": "Flex-module-scss-module__GVHfLa__xl-gap-14",
  "xl-gap-16": "Flex-module-scss-module__GVHfLa__xl-gap-16",
  "xl-gap-18": "Flex-module-scss-module__GVHfLa__xl-gap-18",
  "xl-gap-2": "Flex-module-scss-module__GVHfLa__xl-gap-2",
  "xl-gap-20": "Flex-module-scss-module__GVHfLa__xl-gap-20",
  "xl-gap-22": "Flex-module-scss-module__GVHfLa__xl-gap-22",
  "xl-gap-24": "Flex-module-scss-module__GVHfLa__xl-gap-24",
  "xl-gap-3": "Flex-module-scss-module__GVHfLa__xl-gap-3",
  "xl-gap-4": "Flex-module-scss-module__GVHfLa__xl-gap-4",
  "xl-gap-5": "Flex-module-scss-module__GVHfLa__xl-gap-5",
  "xl-gap-6": "Flex-module-scss-module__GVHfLa__xl-gap-6",
  "xl-gap-8": "Flex-module-scss-module__GVHfLa__xl-gap-8",
  "xl-justify-around": "Flex-module-scss-module__GVHfLa__xl-justify-around",
  "xl-justify-between": "Flex-module-scss-module__GVHfLa__xl-justify-between",
  "xl-justify-center": "Flex-module-scss-module__GVHfLa__xl-justify-center",
  "xl-justify-end": "Flex-module-scss-module__GVHfLa__xl-justify-end",
  "xl-justify-evenly": "Flex-module-scss-module__GVHfLa__xl-justify-evenly",
  "xl-justify-start": "Flex-module-scss-module__GVHfLa__xl-justify-start",
  "xl-wrap-nowrap": "Flex-module-scss-module__GVHfLa__xl-wrap-nowrap",
  "xl-wrap-wrap": "Flex-module-scss-module__GVHfLa__xl-wrap-wrap",
  "xl-wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__xl-wrap-wrap-reverse",
  "xxl-align-baseline": "Flex-module-scss-module__GVHfLa__xxl-align-baseline",
  "xxl-align-center": "Flex-module-scss-module__GVHfLa__xxl-align-center",
  "xxl-align-end": "Flex-module-scss-module__GVHfLa__xxl-align-end",
  "xxl-align-start": "Flex-module-scss-module__GVHfLa__xxl-align-start",
  "xxl-align-stretch": "Flex-module-scss-module__GVHfLa__xxl-align-stretch",
  "xxl-dir-column": "Flex-module-scss-module__GVHfLa__xxl-dir-column",
  "xxl-dir-column-reverse": "Flex-module-scss-module__GVHfLa__xxl-dir-column-reverse",
  "xxl-dir-row": "Flex-module-scss-module__GVHfLa__xxl-dir-row",
  "xxl-dir-row-reverse": "Flex-module-scss-module__GVHfLa__xxl-dir-row-reverse",
  "xxl-gap-0": "Flex-module-scss-module__GVHfLa__xxl-gap-0",
  "xxl-gap-1": "Flex-module-scss-module__GVHfLa__xxl-gap-1",
  "xxl-gap-10": "Flex-module-scss-module__GVHfLa__xxl-gap-10",
  "xxl-gap-12": "Flex-module-scss-module__GVHfLa__xxl-gap-12",
  "xxl-gap-14": "Flex-module-scss-module__GVHfLa__xxl-gap-14",
  "xxl-gap-16": "Flex-module-scss-module__GVHfLa__xxl-gap-16",
  "xxl-gap-18": "Flex-module-scss-module__GVHfLa__xxl-gap-18",
  "xxl-gap-2": "Flex-module-scss-module__GVHfLa__xxl-gap-2",
  "xxl-gap-20": "Flex-module-scss-module__GVHfLa__xxl-gap-20",
  "xxl-gap-22": "Flex-module-scss-module__GVHfLa__xxl-gap-22",
  "xxl-gap-24": "Flex-module-scss-module__GVHfLa__xxl-gap-24",
  "xxl-gap-3": "Flex-module-scss-module__GVHfLa__xxl-gap-3",
  "xxl-gap-4": "Flex-module-scss-module__GVHfLa__xxl-gap-4",
  "xxl-gap-5": "Flex-module-scss-module__GVHfLa__xxl-gap-5",
  "xxl-gap-6": "Flex-module-scss-module__GVHfLa__xxl-gap-6",
  "xxl-gap-8": "Flex-module-scss-module__GVHfLa__xxl-gap-8",
  "xxl-justify-around": "Flex-module-scss-module__GVHfLa__xxl-justify-around",
  "xxl-justify-between": "Flex-module-scss-module__GVHfLa__xxl-justify-between",
  "xxl-justify-center": "Flex-module-scss-module__GVHfLa__xxl-justify-center",
  "xxl-justify-end": "Flex-module-scss-module__GVHfLa__xxl-justify-end",
  "xxl-justify-evenly": "Flex-module-scss-module__GVHfLa__xxl-justify-evenly",
  "xxl-justify-start": "Flex-module-scss-module__GVHfLa__xxl-justify-start",
  "xxl-wrap-nowrap": "Flex-module-scss-module__GVHfLa__xxl-wrap-nowrap",
  "xxl-wrap-wrap": "Flex-module-scss-module__GVHfLa__xxl-wrap-wrap",
  "xxl-wrap-wrap-reverse": "Flex-module-scss-module__GVHfLa__xxl-wrap-wrap-reverse",
});
